import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a5e70de"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5e70de')) {
      api.createRecord('0a5e70de', component.options)
    } else {
      api.reload('0a5e70de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a5e70de", function () {
      api.rerender('0a5e70de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsConfig/index.vue"
export default component.exports